<template>
  <div class="ExamPaperSet" >
    <div style="text-align: center;padding-top: 50px">
      <h1 style="padding: 20px 0">试卷样式设置</h1>
      <el-button type="primary" @click="openSetDialog(2)">前置页面设置</el-button>
      <el-button type="primary" @click="openSetDialog(3)" style="padding: 12px 34px">样式设置</el-button>
      <!--<el-row v-for="(one,index) in examPaperInfo.blockList" :key="'block_'+index">-->
      <el-row style="margin: 20px 0 50px 0">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"  >
         <span style="margin-right: 20px;font-size: 16px" v-for="(one,index) in examPaperInfo.blockList" :key="'block_'+index">
           {{one.BLOCK_NAME}}:<el-button style="margin-left: 10px" type="primary" @click="openSetDialog(4,one.E_P_B_ID)">前置页面设置</el-button>
           <el-input style="width:170px" placeholder="秒" v-model="examPaperInfo['prevSet_'+one.E_P_B_ID].limitTime">
              <template slot="prepend">时长:</template>
            </el-input>
          </span>
        </el-col>
      </el-row>

      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"  >
          <el-button type="primary" @click="saveExamPaperSet" style="padding: 12px 48px"
            :loading="fullscreenLoading"
          >
            保存
          </el-button>
        </el-col>
      </el-row>
    </div>

    <el-dialog v-if="addDialogFlag"
      :title="addDialogTitle"
      :visible.sync="addDialogFlag"
      width=98%
      top="1vh"
      center
      append-to-body>
          <!-- 试卷前置页面设置 -->
          <QuestionPrevSet v-model="examPaperInfo.prevSet" v-if="addDialogPageType == 2" :showType="showType*1"></QuestionPrevSet>
          <!-- 试卷样式设置 -->
          <QuestionCssSet v-model="examPaperInfo.cssSet" v-if="addDialogPageType == 3" :showType="showType*1"></QuestionCssSet>
          <!-- 试卷块前置页面设置 -->
          <QuestionPrevSet v-model="examPaperInfo['prevSet_'+blockId]" v-if="addDialogPageType == 4" :showType="showType*1"></QuestionPrevSet>
    </el-dialog>
  </div>
</template>

<script>
import QuestionPrevSet  from './QuestionPrevSet.vue';
import QuestionCssSet  from './QuestionCssSet.vue';
export default {
  name: 'ExamPaperSet',
  props: {
  },
  data() {
    return {
      examPaperId:0,
      examPaperInfo:{},
      showType:1,
      //弹出层的打开状态
      addDialogFlag:false,
      //弹出层打开的内容类型
      addDialogPageType:0,
      //弹出层打开的弹出层的名称
      addDialogTitle:"选择层",
      //打开弹出层的页面信息
      addDialogPageInfo:{},
      fullscreenLoading:false,
      stateId:0
    };
  },
  created() {
    //获取页面传递的 试卷ID 读取试卷的设置信息
    var that = this;
    //请求地址传递的参数
    var paramsJson = this.$route.query;
    console.log("paramsJson=====================",paramsJson);
    if(paramsJson.examPaperId) {
      that.examPaperId = paramsJson.examPaperId;
    } else {
      paramsJson = this.$route.params;
      that.examPaperId = paramsJson.examPaperId;
    }
    that.getExamPaperSet();
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{},
  components: {
    QuestionPrevSet,
    QuestionCssSet
  },
  methods: {
    /**
     * 去后台请求试题信息
     */
    getExamPaperSet(){
      var that = this;
      var examPaperId = this.examPaperId;
      var url = "/vueQuestion_getExamPaperSet.do";
      var toHtData = {};
      toHtData.examPaperId = examPaperId;
      this.$axios.post(url,toHtData).then(res => {
        if (res.data) {
          that.examPaperInfo = res.data;
        }
      }).catch(error => {
        console.log("=====" + error);
      })
    },
    saveExamPaperSet(){
      var that = this;
      var examPaperId = this.examPaperId;
      var url = "/vueQuestion_saveExamPaperSet.do";
      var toHtData = {};
      toHtData.examPaperId = examPaperId;
      console.log("that.examPaperInfo===================",that.examPaperInfo);
      toHtData.examPaperInfo = JSON.stringify(that.examPaperInfo);
      this.fullscreenLoading = true;
      this.$axios.post(url,toHtData).then(res => {
        that.fullscreenLoading = false;
        if(res.data > 0) {
          that.$message({
            showClose: true,
            message: "保存成功!",
            type: 'success'
          });
        } else {
          that.$message({
            showClose: true,
            message: "保存失败,请重试!",
            type: 'error'
          });
        }
      }).catch(error => {
        console.log("=====" + error);
      })
    },
    /**
     * 打开试题设置的弹出层
     */
    openSetDialog(type,blockId){
      console.log("blockId=======================",blockId);
      if(!this.examPaperInfo.prevSet) {
        this.$set(this.examPaperInfo, "prevSet", {});
      }
      if(!this.examPaperInfo.cssSet) {
        this.$set(this.examPaperInfo, "cssSet", {});
      }
      //打开弹出层 进行数据加载
      this.addDialogPageType = type;
      this.addDialogFlag = true;
      if(type == 4) {
        this.blockId = blockId;
        if(!this.examPaperInfo["prevSet_"+blockId]) {
          this.$set(this.examPaperInfo, "prevSet_"+blockId, {});
        }
      }
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
